export const initialState = {
  firstName: '',
  lastName: '',
  timeZone: '',
  id: null,
  services: [],
  isChangeAvatar: false,
  refetch: () => {}
}
